export default "__VITE_ASSET__36dc6635__"